"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Converter = void 0;
class Converter {
    constructor({ encode, decode }) {
        this._encode = encode;
        this._decode = decode;
    }
    decode(documentSnapshot) {
        const obj = Object.assign({ id: documentSnapshot.id }, documentSnapshot.data());
        if (this._decode)
            return this._decode(obj);
        return obj;
    }
    encode(obj) {
        if (this._encode)
            return this._encode(obj);
        const doc = Object.assign({}, obj);
        if ('id' in doc)
            delete doc.id;
        return doc;
    }
}
exports.Converter = Converter;
//# sourceMappingURL=converter.js.map